import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import { buyMainOffer } from 'publisher/api/mollieApi'
import usePaymentSubmit from 'publisher/hooks/payment/usePaymentSubmit'
import { pageSelectors, usePage, usePayment } from 'publisher/store'
import paymentSelectors from 'publisher/store/payment/paymentSelectors'
import React from 'react'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'

export default function useMolliePaymentHandler(
  entity:
    | OldEntityInterface
    | PaymentButtonEntityInterface
    | BookingPaidCalendarInterface
    | TwoStepPaymentFormStepInterface,
) {
  const { errors, isLoading, submit } = usePaymentSubmit(entity)
  const purchaseProcessId = usePayment(paymentSelectors.getPurchaseProcessId)
  const pageId = usePage(pageSelectors.getPageId)

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    submit(async body => {
      const { data } = await buyMainOffer(pageId, purchaseProcessId, {
        payment_form: body,
      })

      if (data.redirect) {
        window.location.assign(data.redirect)
        return
      }
    })
  }

  return { errors, isLoading, handleSubmit }
}
